import { PATH, request } from "components/shared/Api";
import React, { useEffect, useState } from "react";

import BoardNoticeDetail from "./BoardNoticeDetail";
import Header from "components/ui/common/Header";
import { useNavigate } from "react-router-dom";

const CommonBoard = ({
  receivedState,
  title,
  setTitle,
  boardNm,
  setBoardNm,
  boardType,
  setBoardType,
  boardList,
  setDetailBoardCd,
  setIsEnrollBoard,
  setIsCommonBoardDetail,
  setCheckEdit,
  set_show_bottom_sheet,
  set_show_search_box,
  inViewRef,
  setIsAlert,
  setModalMsg,
  dt,
  order_by,
  type,
  category,
  is_loading,
  set_is_loading,
}) => {
  const navigate = useNavigate();
  const [boardNotice, setBoardNotice] = useState([]);
  const [isBoardNoticeDetail, setIsBoardNoticeDetail] = useState(false);
  const [noticeBoardCd, setNoticeBoardCd] = useState("");
  const [camoTitle, setCamoTitle] = useState("");

  //게시판공지 api
  const handleGetBoardNotice = async () => {
    try {
      const response = await request(PATH.게시판공지, {
        boardNm: boardNm,
        lastBoardCd: "",
      });
      if (response.data.code === "0000") {
        setBoardNotice(response.data.boardNotice);
      } else if (response.data.code !== "0000" && !receivedState && boardNm !== "") {
        setIsAlert(true);
        setModalMsg(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const pageChange = (page) => {
    if (window.ReactNativeWebView) {
      const message = { navigate: page };
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    } else {
      navigate("/" + page);
    }
  };

  const handleGoBack = () => {
    if (receivedState) {
      pageChange("main");
    } else {
      setTitle("");
    }
  };

  useEffect(() => {
    if (title === "지식산업센터") {
      setBoardNm("정보공유");
      setBoardType("지식산업센터");
    } else if (title === "오피스텔빌딩") {
      setBoardNm("정보공유");
      setBoardType("오피스텔빌딩");
      setCamoTitle("오피스텔/빌딩");
    } else if (title === "구인구직") {
      setBoardNm("구인구직");
      setBoardType("");
      setCamoTitle("구인/구직");
    } else if (title === "자유게시판") {
      setBoardNm("자유게시판");
      setBoardType("");
    } else if (title === "기타") {
      setBoardNm("정보공유");
      setBoardType("기타");
    }
  }, []);

  useEffect(() => {
    handleGetBoardNotice();
  }, [boardNm, boardType]);
  console.log("boardNm:::" + boardNm);
  console.log("boardType:::" + boardType);

  return (
    <React.Fragment>
      {isBoardNoticeDetail ? (
        <BoardNoticeDetail
          noticeBoardCd={noticeBoardCd}
          setNoticeBoardCd={setNoticeBoardCd}
          setIsBoardNoticeDetail={setIsBoardNoticeDetail}
          is_loading={is_loading}
          set_is_loading={set_is_loading}
        />
      ) : (
        <div className="wrapper community">
          <Header Title={camoTitle ? camoTitle : title} handleGoBack={handleGoBack} />
          <div className="content p0">
            <div className="notice-community">
              {boardNotice &&
                boardNotice.map((v, i) => (
                  <div
                    key={i}
                    className="item"
                    onClick={() => {
                      setNoticeBoardCd(v.boardCd);
                      setIsBoardNoticeDetail(true);
                    }}
                  >
                    <i className="ico-notice"></i>
                    <p>{v.boardTitle}</p>
                  </div>
                ))}
            </div>

            <div className="filter-bar">
              <div className="left-box">
                <ul className="txt-box">
                  <li>{dt}</li>
                  <li>{order_by === "DESC" ? "최신순" : "과거순"}</li>
                  {title !== "자유게시판" && <li>{type === "" ? "전체" : type}</li>}
                  <li>{category === "" ? "전체" : category}</li>
                </ul>
              </div>
              <div className="right-box justify-between">
                <button
                  type="button"
                  className="ico-filter"
                  onClick={() => {
                    set_show_bottom_sheet(true);
                  }}
                ></button>
                <button
                  type="button"
                  className="ico-search"
                  onClick={() => {
                    set_show_search_box(true);
                  }}
                ></button>
              </div>
            </div>

            <div className="community-list community-list3">
              {boardList.length > 0 ? (
                boardList.map((v, i) => (
                  <div
                    className="list-box"
                    key={i}
                    onClick={() => {
                      setDetailBoardCd(v.boardCd);
                      setIsCommonBoardDetail(true);
                    }}
                  >
                    <p className="tit txt1">
                      <span>{"[" + v.boardCategory + "]"} </span>
                      {v.boardTitle}
                    </p>

                    <div className="justify-between">
                      <p className="txt2">
                        {v.regDtm.substring(0, 4)}.{v.regDtm.substring(5, 7)}.{v.regDtm.substring(8, 10)}{" "}
                        {v.regDtm.substring(11, 16)}
                      </p>
                      <ul className="num-box">
                        <li>
                          <i className="ico-view"></i>
                          {v.viewCount}
                        </li>
                        <li>
                          <i className="ico-comment"></i>
                          {v.refCount}
                        </li>
                      </ul>
                    </div>
                  </div>
                ))
              ) : boardList.length === 0 && !is_loading ? (
                <div className="no-content">
                  <i className="ico-no-content"></i>
                  <p>조회하신 내역이 없습니다.</p>
                </div>
              ) : null}
            </div>
            <div ref={inViewRef} style={{ height: "1px" }} />

            <div className="writing-btn">
              <button
                type="button"
                className="flex-center"
                onClick={() => {
                  setIsEnrollBoard(true);
                  setCheckEdit(false);
                }}
              >
                <i className="ico-plus-white"></i>
                글쓰기
              </button>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default CommonBoard;
